import React, { useEffect, useState } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'

const ReportDetails = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [sortKey, setSortKey] = useState("CREATEDTIME");
  const [sortOrder, setSortOrder] = useState("desc");
  const [formdata, setFormdata] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false)
  const email = sessionStorage.getItem('email');

  const navigate = useNavigate();

  const formatToMMDDYYYY = (dateInput) => {
    if (!dateInput && dateInput !== 0) return "";
    const s = String(dateInput).trim();

    // If already in DD-MM-YYYY form (simple check)
    if (/^\d{2}-\d{2}-\d{4}$/.test(s)) return `${s.split('-')[1]}-${s.split('-')[0]}-${s.split('-')[2]}`;

    // Try to extract YYYY-MM-DD from strings like '2025-12-09' or '2025-12-09 22:26:10:284'
    const isoMatch = s.match(/(\d{4})-(\d{2})-(\d{2})/);
    if (isoMatch) {
      const [, y, m, d] = isoMatch;
      return `${m}-${d}-${y}`;
    }

    // Fallback: try Date parsing
    const parsed = new Date(s);
    if (!isNaN(parsed)) {
      const dd = String(parsed.getDate()).padStart(2, "0");
      const mm = String(parsed.getMonth() + 1).padStart(2, "0");
      const yyyy = parsed.getFullYear();
      return `${mm}-${dd}-${yyyy}`;
    }

    // If all else fails, return original string
    return s;
  };

  const formatCreatedTime = (dateInput) => {
    if (!dateInput && dateInput !== 0) return "";
    const s = String(dateInput).trim();

    let timePart = s.includes(' ') ? s.split(' ')[1] : (s.includes('T') ? s.split('T')[1] : s);
    timePart = timePart.split('.')[0].replace(/Z$/, '');
    const parts = timePart.split(':').filter(Boolean);
    if (parts.length >= 3) {
      return `${parts[0].padStart(2, '0')}:${parts[1].padStart(2, '0')}:${parts[2].padStart(2, '0')}`;
    }
    if (parts.length === 2) {
      return `${parts[0].padStart(2, '0')}:${parts[1].padStart(2, '0')}`;
    }

    return timePart;
  };
  useEffect(() => {
    const fetchform = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`/server/forms/get-report-forms/${email}`);
        const data = response.data.data;
        setFormdata(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching uploads:", error);
      }
    };
    fetchform();
  }, [email]);

  const filteredData = formdata
    .filter(item =>
      formatToMMDDYYYY(item.CREATEDTIME).toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      const valA = a[sortKey] || "";
      const valB = b[sortKey] || "";
      return sortOrder === "asc"
        ? valA.localeCompare(valB)
        : valB.localeCompare(valA);
    });

  const handleSort = key => {
    if (sortKey === key) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortKey(key);
      setSortOrder("asc");
    }
  };
  const handleViewClick = (item) => {
    navigate('/report-view', { state: { item } });
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedItem(null);
  };
  if (loading) {
    return (
      <Sidebar>


        <div className="h-screen flex items-center justify-center bg-white">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-red-500 border-t-transparent"></div>
        </div>
      </Sidebar>
    );
  }

  return (
    <Sidebar>
      <div className="bg-white shadow rounded-xl p-4 mb-6">
        <h2 className="text-xl font-semibold mb-4">Report Details</h2>
        {/* <input
          type="text"
          placeholder="Search by form name"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          className="border rounded px-3 py-1 mb-3 w-1/3"
        /> */}
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm text-left">
            <thead className="bg-[#EF7320] text-white">
              <tr>
                {["store_id", "form_name", "reported_date", "reported_by", 'created Time', "action"].map(col => (
                  <th
                    key={col}
                    onClick={() => handleSort(col)}
                    className="px-4 py-2 cursor-pointer"
                  >
                    {col.replace(/_/g, " ").toUpperCase()}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredData?.map((item, idx) => (
                <tr key={idx} className="bg-gray-100 border-b">
                  <td className="px-4 py-2">{item.store_id}</td>
                  <td className="px-4 py-2">{item.formname}</td>
                  <td className="px-4 py-2">{formatToMMDDYYYY(item.reported_date)}</td>
                  <td className="px-4 py-2">{item.reported_by}</td>
                  <td className="px-4 py-2">
                    {(() => {
                      const d = formatToMMDDYYYY(item.CREATEDTIME);
                      const t = formatCreatedTime(item.CREATEDTIME);
                      if (d && t) return `${d} ${t}`;
                      return d || t || "";
                    })()}
                  </td>
                  <td className="py-2">
                    <button
                      onClick={() => handleViewClick(item)}
                      className="text-white bg-amber-600 p-2 rounded-2xl w-20"
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>



    </Sidebar>
  );
};

export default ReportDetails;
